import React, { useMemo } from 'react';
import { StyledWaveform } from './index.style';

// Keep a thin sliver along the baseline through silence, like classic editors.
const MIN_AMP = 0.04;

/**
 * Peaks (0..1) drawn as one filled envelope mirrored around the centre line
 * (classic Audacity/SoundCloud look). Built once; the viewBox stretches it to
 * its box at any zoom via preserveAspectRatio="none".
 *
 * Track-agnostic: `color` sets the fill, so media / voice / music can each use
 * their own without touching this component.
 */
const Waveform = ({ peaks, color }) => {
  const d = useMemo(() => {
    if (peaks.length < 2) return '';
    const y = (i, sign) =>
      (0.5 + (sign * Math.max(peaks[i], MIN_AMP)) / 2).toFixed(3);
    // Top envelope left-to-right, then the bottom envelope back, closed.
    const parts = [`M 0 ${y(0, -1)}`];
    for (let i = 1; i < peaks.length; i += 1) parts.push(`L ${i} ${y(i, -1)}`);
    for (let i = peaks.length - 1; i >= 0; i -= 1) {
      parts.push(`L ${i} ${y(i, 1)}`);
    }
    parts.push('Z');
    return parts.join(' ');
  }, [peaks]);

  if (!d) return null;

  return (
    <StyledWaveform
      viewBox={`0 0 ${peaks.length - 1} 1`}
      preserveAspectRatio="none"
      style={{ color }}
    >
      <path d={d} />
    </StyledWaveform>
  );
};

export default Waveform;
